import React from "react";
import {
  List,
  DataTable,
  TextField,
  Pagination,
  Button,
  TopToolbar,
  ColumnsButton,
  DeleteButton,
  useNotify,
  useRecordContext,
} from "react-admin";
import { CustomDatetimeField } from "../lib/datetime";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import { httpClient } from "../lib/httpClient";

const ChatNotificationButton = () => {
  const notify = useNotify();
  const record = useRecordContext();

  const handleSendChatNotification = async () => {
    if (!record) {
      console.log("No record set. Aborting notification request.");
      return;
    }

    try {
      const resp = await httpClient(
        `/api/v2/c/${record.customerID}/appinstance/${record.id}/notify`,
        {
          method: "POST",
        },
      );

      if (resp.ok) {
        notify(
          `Successfully sent chat notification to customer ${record.customerID}, device ${record.deviceName}`,
          { type: "success" },
        );
      } else {
        notify(
          `Failed to notify customer ${record.customerID}, device ${record.deviceName}`,
          { type: "error" },
        );
      }
    } catch (err) {
      notify(
        `Failed to notify customer ${record.customerID}, device ${record.deviceName}`,
        { type: "error" },
      );
    }
  };

  return (
    <Button
      size="medium"
      onClick={handleSendChatNotification}
      label="Send Chat Notification"
    >
      <ChatBubbleIcon />
    </Button>
  );
};

export const AppInstanceList = () => (
  <List
    perPage={100}
    pagination={<Pagination rowsPerPageOptions={[100, 200, 500, 1000]} />}
    exporter={false}
    actions={
      <TopToolbar>
        <ColumnsButton />
      </TopToolbar>
    }
    sort={{ field: "lastLogin", order: "DESC" }}
    storeKey={false}
    empty={false}
  >
    <DataTable bulkActionButtons={false} rowClick={false}>
      <DataTable.Col source="deviceName" label="Device Name">
        <TextField source="deviceName" label="Device Name" />
      </DataTable.Col>
      <DataTable.Col source="lastLogin" label="Last Login">
        <CustomDatetimeField source="lastLogin" label="Last Login" />
      </DataTable.Col>
      <DataTable.Col>
        <ChatNotificationButton />
      </DataTable.Col>
      <DataTable.Col>
        <DeleteButton size="medium" mutationMode="pessimistic" />
      </DataTable.Col>
    </DataTable>
  </List>
);
